import { axios, base } from '../http';

export const saveSchoolDataOverviewConfig = (params) => {
  return axios.post(`${base}/api/department/SaveSchoolDataOverviewConfig`, params);
};
// 教师数据概览配置

export const getDepartmentListPage = (params) => {
  return axios.get(`${base}/api/department/get`, { params: params });
};

/** 按部门 ID 获取详情（含 SchType）。对应 GET /api/department/get/{id}。最后更新：2026-08-30 */
export const getDepartmentById = (id) => {
  return axios.get(`${base}/api/department/get/${encodeURIComponent(id)}`);
};

/** 把部门 ID 入参收成数组。字符串、单个数字、Set 都可，避免对非数组调用 map。最后更新：2026-10-15 */
function coerceDepartmentIdList(ids) {
  if (ids == null || ids === '') return []
  if (Array.isArray(ids)) return ids
  if (typeof ids === 'string' || typeof ids === 'number' || typeof ids === 'bigint') {
    return String(ids).split(',')
  }
  if (typeof ids === 'object' && typeof ids[Symbol.iterator] === 'function') {
    return Array.from(ids)
  }
  return []
}

/** 批量解析部门名称（雪花 ID 走字符串，避免精度丢失）。最后更新：2026-10-15 */
export async function getDepartmentNamesMap(ids) {
  const uniqueIds = [...new Set(coerceDepartmentIdList(ids)
    .map((id) => String(id == null ? '' : id).trim())
    .filter(Boolean))]
  const nameMap = {}
  if (!uniqueIds.length) return nameMap

  await Promise.all(uniqueIds.map(async (id) => {
    try {
      const res = await getDepartmentById(id)
      const dept = res.data && res.data.response
      if (!dept) return
      const name = dept.Name || dept.name || dept.label
      if (name) nameMap[id] = name
    } catch (e) {
      // 部门可能已删除，忽略单项失败
    }
  }))
  return nameMap
}

//根据机构查询人员类型

export const getStudentLiveTypeList = (params) => {
  return axios.get(`${base}/api/department/GetStudentLiveType`, {
    params: params,
  });
};

/** 按学校 SchId 查询有效人员类型。最后更新：2026-09-15 */
export const getStudentLiveTypeBySchId = (params) => {
  return axios.get(`${base}/api/department/GetStudentLiveTypeBySchId`, {
    params: params,
  });
};

/** 保存本校人员类型命名。最后更新：2026-09-15 */
export const saveStudentLiveType = (params) => {
  return axios.post(`${base}/api/department/SaveStudentLiveType`, params);
};

//根据当前机构ID获取学校信息

export const getDepartmentType = (params) => {
  return axios.get(`${base}/api/department/GetDepartmentType`, {
    params: params,
  });
};

//根据部门ID获取所有下级的年级信息

export const getSubGrades = (params) => {
  return axios.get(`${base}/api/department/GetSubGrades`, {
    params: params,
  });
};

// 校园风采模块

export const getDepartmentTreeTable = (params) => {
  return axios.get(`${base}/api/department/getTreeTable`, { params: params });
};

export const getSchTreeTable = (params) => {
  return axios.get(`${base}/api/department/GetSchoolTreeTable`, {
    params: params,
  });
};

/** 导出机构列表（学校），筛选条件与列表一致。创建于 2026-09-23 */
export const exportSchoolTreeTable = (params) => {
  return axios.get(`${base}/api/department/ExportSchoolTreeTable`, {
    params: params,
    responseType: "blob",
  });
};

// 获取应用菜单配置

export const getAppMenuConfig = (params) => {
  return axios.get(`${base}/api/department/getAppMenuConfig`, {
    params: params,
  });
};

// 更新应用菜单配置

export const updateAppMenuConfig = (params) => {
  return axios.post(`${base}/api/department/UpdateAppMenuConfig`, params);
};

//新增/更新订餐配置

export const setOrderFood = (params) => {
  return axios.post(`${base}/api/department/SetOrderFood`, params);
};

/** 获取平台 OSS 各类型默认 Bucket（appsettings AliyunOss） */

export const getOssPlatformDefaults = () => {
  return axios.get(`${base}/api/Department/GetOssPlatformDefaults`);
};

// 学校排课管理设置列表

const _deptTreeCache = new Map();
const _deptTreeInflight = new Map();
const _deptTreeTtl = 5 * 60 * 1000;

function _getCurrentUserCacheId() {
  try {
    const user = window.localStorage.user ? JSON.parse(window.localStorage.user) : null;
    if (user) {
      const id = user.uID != null && user.uID !== '' ? user.uID
        : user.uId != null && user.uId !== '' ? user.uId
        : user.id != null && user.id !== '' ? user.id
        : user.ID != null && user.ID !== '' ? user.ID
        : user.sub;
      if (id != null && id !== '') return String(id);
    }
    const token = window.localStorage.getItem('Token');
    return token ? ('token:' + token.slice(0, 24)) : 'guest';
  } catch (e) {
    return 'guest';
  }
}

function _normalizeDeptTreeParams(params) {
  const source = params || {};
  // 部门 Id 可能是雪花，超过 Number 安全整数时必须保留字符串
  const toDeptId = (value, defaultValue) => {
    if (value === undefined || value === null || value === '') return defaultValue;
    const str = String(value).trim();
    if (!/^-?\d+$/.test(str)) return defaultValue;
    if (str.length > 15) return str;
    const num = Number(str);
    return Number.isSafeInteger(num) ? num : str;
  };
  const toNumber = (value, defaultValue) => {
    if (value === undefined || value === null || value === '') return defaultValue;
    const result = Number(value);
    return Number.isFinite(result) ? result : defaultValue;
  };
  return {
    pid: toDeptId(source.pid, 0),
    type: toNumber(source.type, 0),
    bigType: toNumber(source.bigType, 0),
    scopeDepartmentId: toDeptId(source.scopeDepartmentId, 0),
  };
}

/**
 * 将明确的业务范围转换为旧接口参数，供全站逐步迁移复用。
 * switchable 仅保留调用方显式传入的 type/bigType，不改变旧页面语义。
 */
export function withDepartmentScope(directoryScope, params) {
  const source = Object.assign({}, params || {});
  const scopeMap = {
    teaching: { type: 0, bigType: 1 },
    internal: { type: 0, bigType: 0 },
    school: { type: 1, bigType: 0 },
  };
  return Object.assign(source, scopeMap[directoryScope] || {});
}

function _deptTreeKey(params) {
  return _getCurrentUserCacheId() + '|' + JSON.stringify(_normalizeDeptTreeParams(params));
}

/**
 * 主动清除部门树前端缓存（增删改部门后调用）
 */

export function clearDeptTreeCache() {
  _deptTreeCache.clear();
}

export const removeDepartment = (params) => {
  return axios.delete(`${base}/api/department/delete`, { params: params }).then((res) => {
    if (res.data && res.data.success) clearDeptTreeCache();
    return res;
  });
};

export const editDepartment = (params) => {
  return axios.put(`${base}/api/department/put`, params).then((res) => {
    if (res.data && res.data.success) clearDeptTreeCache();
    return res;
  });
};

export const addDepartment = (params) => {
  return axios.post(`${base}/api/department/post`, params).then((res) => {
    if (res.data && res.data.success) clearDeptTreeCache();
    return res;
  });
};

export const getDepartmentTree = (params, options) => {
  // 范围名必须先写成对象里的 bigType。字符串会被归一成全 0，线上就会变成内部通讯录。最后更新：2026-09-24
  if (typeof params === 'string' || typeof params === 'number') {
    return Promise.reject(new Error('getDepartmentTree 需要参数对象'));
  }
  const normalizedParams = _normalizeDeptTreeParams(params);
  const key = _deptTreeKey(normalizedParams);
  const bypassCache = !!(options && options.bypassCache);
  if (!bypassCache) {
    const cached = _deptTreeCache.get(key);
    if (cached && Date.now() < cached.expireAt) {
      return Promise.resolve(cached.data);
    }
    // 并发同参请求共用一个 Promise，避免登录后双触发打两次接口
    const inflight = _deptTreeInflight.get(key);
    if (inflight) {
      return inflight;
    }
  }
  const req = axios.get(`${base}/api/department/getDepartmentTree`, { params: normalizedParams }).then((res) => {
    // 拦截器失败时会 resolve 成 { success:false }，这种结果不能缓存，否则部门树会空 5 分钟。最后更新：2026-10-15
    const body = res && res.data
    if (body && body.success !== false && body.response) {
      _deptTreeCache.set(key, { data: res, expireAt: Date.now() + _deptTreeTtl });
    }
    return res;
  }).finally(() => {
    if (!bypassCache) {
      _deptTreeInflight.delete(key);
    }
  });
  if (!bypassCache) {
    _deptTreeInflight.set(key, req);
  }
  return req;
};

/**
 * 仅供本文件里的教学/内部/学校封装调用。
 * 页面不要直接引用：它和 getDepartmentTree 只差一个后缀，打包压缩导出名时可能绑错，字符串范围名会把 bigType 变成 0。
 */
export const getDepartmentTreeByScope = (directoryScope, params, options) => {
  return getDepartmentTree(withDepartmentScope(directoryScope, params), options);
};

/** 获取教学架构树（固定 BigType=1） */
export const getTeachingDepartmentTree = (params, options) => {
  return getDepartmentTreeByScope('teaching', params, options);
};

/** 获取内部通讯录树（固定 BigType=0） */
export const getInternalDepartmentTree = (params) => {
  return getDepartmentTreeByScope('internal', params);
};

/** 获取纯学校选择树 */
export const getSchoolDepartmentTree = (params) => {
  return getDepartmentTreeByScope('school', params);
};

export const getSubDepartmentTree = (params) => {
  return axios.get(`${base}/api/department/getSubDepartmentTree`, {
    params: params,
  });
};

export const getSubDepartmentList = (params) => {
  return axios.get(`${base}/api/department/GetSubDepartmentList`, {
    params: params,
  });
};

//获取班级授权账号列表

export const getClassAuthAccount = (params) => {
  return axios.get(`${base}/api/department/GetClassAuthAccount`, {
    params: params,
  });
};

//导出班级授权账号

export const exportClassAuthAccount = (params) => {
  return axios.get(`${base}/api/department/ExportClassAuthAccount`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//生成班级授权账号

export const generateClassAuth = (params) => {
  return axios.post(`${base}/api/department/GenerateClassAuth`, params);
};

//删除班级授权账号

export const deleteClassAuthAccount = (params) => {
  return axios.delete(`${base}/api/department/DeleteClassAuthAccount`, {
    params: params,
  });
};

//解绑班牌设备（清空班级ID�?

export const unbindTerminal = (params) => {
  return axios.post(`${base}/api/department/UnbindTerminal`, params);
};

//手动授权指定班牌到指定班级账�?

export const manualAuthorizeTerminal = (params) => {
  return axios.post(`${base}/api/department/ManualAuthorizeTerminal`, params);
};

//同步钉钉部门

export const syncDingDingDepartment = (params) => {
  return axios.get(`${base}/api/department/SyncDingDingDepartment`, {
    params: params,
  });
};

/** 固定同步家校（教学）组织 */
export const syncTeachingDingTalkDepartment = (departmentIds) => {
  return syncDingDingDepartment({ id: departmentIds, type: 1 });
};

/** 固定同步内部组织 */
export const syncInternalDingTalkDepartment = (departmentIds) => {
  return syncDingDingDepartment({ id: departmentIds, type: 0 });
};

export const getDingDingDepartmentTree = (params) => {
  return axios.get(`${base}/api/department/GetDingDingDepartmentTree`, {
    params: params,
  });
};

/** 清除钉钉部门树缓存。最后更新：2026-08-30 */
export const clearDingDingDepartmentTreeCache = (params) => {
  return axios.post(`${base}/api/department/ClearDingDingDepartmentTreeCache`, null, {
    params: params,
  });
};

export const syncSelectedDingDingDepartment = (params) => {
  return axios.get(`${base}/api/department/SyncSelectedDingDingDepartment`, {
    params: params,
  });
};

/** 下载教学架构（班级）导入模板 */
export const downloadTeachingStructureImportTemplate = () => {
  return axios.get(`${base}/api/department/DownloadTeachingStructureImportTemplate`, {
    responseType: 'blob',
  });
};

/** 导入教学架构：校区→学段→年级→班级 */
export const importTeachingStructure = (formData, schoolDepartmentId) => {
  return axios
    .post(
      `${base}/api/department/ImportTeachingStructure?schoolDepartmentId=${schoolDepartmentId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    .then((res) => {
      if (res.data && res.data.success) clearDeptTreeCache();
      return res;
    });
};

/** 下载 blob 为 Excel */
export function downloadBlobExcel(res, filePrefix) {
  const blob = new Blob([res.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filePrefix}_${new Date().getTime()}.xlsx`;
  link.click();
  window.URL.revokeObjectURL(url);
}

//同步钉钉人员

export const syncDingDingUser = (params) => {
  return axios.get(`${base}/api/department/SyncDingDingUser`, {
    params: params,
  });
};

//同步钉钉教师

export const syncDingDingTeacher = (params) => {
  return axios.get(`${base}/api/department/SyncDingDingTeacher`, {
    params: params,
  });
};

/** 固定同步内部通讯录教师 */
export const syncInternalDingTalkTeacher = (departmentIds) => {
  return syncDingDingTeacher({ id: departmentIds, type: 0 });
};

/** 提交钉钉同步任务，资源支持 Department、Student、Teacher、All */
export const submitDingTalkSyncTask = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/SubmitTask`, params);
};

/** 钉钉同步任务中心分页 */
export const getDingTalkSyncTaskPage = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/GetTaskPage`, params);
};

/** 获取单个钉钉同步任务 */
export const getDingTalkSyncTask = (taskId) => {
  return axios.get(`${base}/api/DingDingSyncTask/GetTask`, { params: { taskId } });
};

/** 钉钉同步任务明细分页 */
export const getDingTalkSyncTaskDetailPage = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/GetTaskDetailPage`, params);
};

/** 重试失败的钉钉同步任务 */
export const retryDingTalkSyncTask = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/RetryFailedTask`, params);
};

/** 删除钉钉同步任务（含全部明细） */
export const deleteDingTalkSyncTask = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/DeleteTask`, params);
};

/** 批量删除钉钉同步任务（含全部明细） */
export const batchDeleteDingTalkSyncTasks = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/BatchDeleteTasks`, params);
};

/** 删除钉钉同步任务明细 */
export const deleteDingTalkSyncTaskDetail = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/DeleteTaskDetail`, params);
};

/** 批量删除钉钉同步任务明细 */
export const batchDeleteDingTalkSyncTaskDetails = (params) => {
  return axios.post(`${base}/api/DingDingSyncTask/BatchDeleteTaskDetails`, params);
};

//异步同步所有子部门到天波平台，接口立即返回

export const syncAllSubDeptToTb = (params) => {
  return axios.post(`${base}/api/department/syncAllSubDeptToTb`, params);
};

//异步同步所有子部门的学生到天波平台，接口立即返�?

export const syncAllSubDeptStudentToTb = (params) => {
  return axios.post(`${base}/api/department/SyncAllSubDeptStudentToTb`, params);
};

/** 将当前班级已同步学生换到本班的天波部门，不改本地班级。最后更新：2026-10-15 */
export const changeTbStudentsToCurrentClass = (params) => {
  return axios.post(`${base}/api/department/ChangeTbStudentsToCurrentClass`, params);
};

/** 天波学生同步主记录（轮询状态） */

export const getTbStudentSyncLog = (params) => {
  return axios.get(`${base}/api/department/GetTbStudentSyncLog`, { params });
};

/** 天波学生同步明细分页 */

export const getTbStudentSyncLogDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbStudentSyncLogDetailPage`, params);
};

/** 按部门查询天波学生同步历史主表分页 */

export const getTbStudentSyncLogPage = (params) => {
  return axios.post(`${base}/api/department/GetTbStudentSyncLogPage`, params);
};

/** 删除天波学生同步主记录及全部明细 */

export const deleteTbStudentSyncLog = (params) => {
  return axios.post(`${base}/api/department/DeleteTbStudentSyncLog`, params);
};

/** 重试天波学生同步失败项。最后更新：2026-09-01 */
export const retryTbStudentSyncFailed = (params) => {
  return axios.post(`${base}/api/department/RetryTbStudentSyncFailed`, params);
};

/** 查询学生同步当前筛选下可重试明细 ID。最后更新：2026-09-01 */
export const getTbStudentSyncRetryableDetailIds = (params) => {
  return axios.post(`${base}/api/department/GetTbStudentSyncRetryableDetailIds`, params);
};

//异步同步所有子部门的教师到天波平台，接口立即返�?

export const syncAllSubDeptTeacherToTb = (params) => {
  return axios.post(`${base}/api/department/SyncAllSubDeptTeacherToTb`, params);
};

/** 天波教师同步主记录（轮询状态） */

export const getTbTeacherSyncLog = (params) => {
  return axios.get(`${base}/api/department/GetTbTeacherSyncLog`, { params });
};

/** 天波教师同步明细分页 */

export const getTbTeacherSyncLogDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbTeacherSyncLogDetailPage`, params);
};

/** 按部门查询天波教师同步历史主表分页 */

export const getTbTeacherSyncLogPage = (params) => {
  return axios.post(`${base}/api/department/GetTbTeacherSyncLogPage`, params);
};

/** 删除天波教师同步主记录及全部明细 */

export const deleteTbTeacherSyncLog = (params) => {
  return axios.post(`${base}/api/department/DeleteTbTeacherSyncLog`, params);
};

/** 重试天波教师同步失败项。最后更新：2026-09-01 */
export const retryTbTeacherSyncFailed = (params) => {
  return axios.post(`${base}/api/department/RetryTbTeacherSyncFailed`, params);
};

/** 查询教师同步当前筛选下可重试明细 ID。最后更新：2026-09-01 */
export const getTbTeacherSyncRetryableDetailIds = (params) => {
  return axios.post(`${base}/api/department/GetTbTeacherSyncRetryableDetailIds`, params);
};

/** 天波同步统计 */

export const getTbDeptStats = (params) => {
  return axios.get(`${base}/api/department/GetTbDeptStats`, { params });
};

export const getTbStudentStats = (params) => {
  return axios.get(`${base}/api/department/GetTbStudentStats`, { params });
};

export const getTbTeacherStats = (params) => {
  return axios.get(`${base}/api/department/GetTbTeacherStats`, { params });
};

/** 天波同步统计明细分页 */

export const getTbDeptDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbDeptDetailPage`, params);
};

export const getTbStudentDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbStudentDetailPage`, params);
};

export const getTbTeacherDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbTeacherDetailPage`, params);
};

/** 异步同步家长到天波平台 */

export const syncAllSubDeptParentToTb = (params) => {
  return axios.post(`${base}/api/department/SyncAllSubDeptParentToTb`, params);
};

/** 天波家长同步主记录（轮询） */

export const getTbParentSyncLog = (params) => {
  return axios.get(`${base}/api/department/GetTbParentSyncLog`, { params });
};

/** 天波家长同步明细分页 */

export const getTbParentSyncLogDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbParentSyncLogDetailPage`, params);
};

/** 按部门查询天波家长同步历史主表分页 */

export const getTbParentSyncLogPage = (params) => {
  return axios.post(`${base}/api/department/GetTbParentSyncLogPage`, params);
};

/** 删除天波家长同步主记录及全部明细 */

export const deleteTbParentSyncLog = (params) => {
  return axios.post(`${base}/api/department/DeleteTbParentSyncLog`, params);
};

/** 重试天波家长同步失败项。最后更新：2026-09-01 */
export const retryTbParentSyncFailed = (params) => {
  return axios.post(`${base}/api/department/RetryTbParentSyncFailed`, params);
};

/** 查询家长同步当前筛选下可重试明细 ID。最后更新：2026-09-01 */
export const getTbParentSyncRetryableDetailIds = (params) => {
  return axios.post(`${base}/api/department/GetTbParentSyncRetryableDetailIds`, params);
};

export const getTbParentStats = (params) => {
  return axios.get(`${base}/api/department/GetTbParentStats`, { params });
};

export const getTbParentDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbParentDetailPage`, params);
};

/** 从天波删除已同步学生并清本地 TbThirdPartId */

export const deleteSubDeptStudentFromTb = (params) => {
  return axios.post(`${base}/api/department/DeleteSubDeptStudentFromTb`, params);
};

/** 从天波删除已同步教师并清本地 TbThirdPartId */

export const deleteSubDeptTeacherFromTb = (params) => {
  return axios.post(`${base}/api/department/DeleteSubDeptTeacherFromTb`, params);
};

/** 从天波删除已同步家长并清映射 */

export const deleteSubDeptParentFromTb = (params) => {
  return axios.post(`${base}/api/department/DeleteSubDeptParentFromTb`, params);
};

/** 仅清除本地部门天波ID（不调厂家删除；不清除学校根） */
export const clearLocalTbDeptIds = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbDeptIds`, params);
};

/** 仅清除本地学生天波ID */
export const clearLocalTbStudentIds = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbStudentIds`, params);
};

/** 仅清除本地教师天波ID */
export const clearLocalTbTeacherIds = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbTeacherIds`, params);
};

/** 仅清除本地家长天波映射 */
export const clearLocalTbParentMappings = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbParentMappings`, params);
};

/** 单条：清除本地部门天波ID。最后更新：2026-10-21 */
export const clearLocalTbDeptIdItem = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbDeptIdItem`, params);
};

/** 单条：清除本地学生天波ID */
export const clearLocalTbStudentIdItem = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbStudentIdItem`, params);
};

/** 单条：清除本地教师天波ID */
export const clearLocalTbTeacherIdItem = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbTeacherIdItem`, params);
};

/** 单条：清除本地家长天波映射 */
export const clearLocalTbParentMappingItem = (params) => {
  return axios.post(`${base}/api/department/ClearLocalTbParentMappingItem`, params);
};

/** 单条：从天波删除部门 */
export const deleteTbDeptItem = (params) => {
  return axios.post(`${base}/api/department/DeleteTbDeptItem`, params);
};

/** 单条：从天波删除学生 */
export const deleteTbStudentItem = (params) => {
  return axios.post(`${base}/api/department/DeleteTbStudentItem`, params);
};

/** 单条：从天波删除教师 */
export const deleteTbTeacherItem = (params) => {
  return axios.post(`${base}/api/department/DeleteTbTeacherItem`, params);
};

/** 单条：从天波删除家长 */
export const deleteTbParentItem = (params) => {
  return axios.post(`${base}/api/department/DeleteTbParentItem`, params);
};

/** 单条：同步部门到天波 */
export const syncTbDeptItem = (params) => {
  return axios.post(`${base}/api/department/SyncTbDeptItem`, params);
};

/** 单条：同步学生到天波 */
export const syncTbStudentItem = (params) => {
  return axios.post(`${base}/api/department/SyncTbStudentItem`, params);
};

/** 单条：同步教师到天波 */
export const syncTbTeacherItem = (params) => {
  return axios.post(`${base}/api/department/SyncTbTeacherItem`, params);
};

/** 单条：同步家长到天波 */
export const syncTbParentItem = (params) => {
  return axios.post(`${base}/api/department/SyncTbParentItem`, params);
};

/** 天波部门同步日志 */

export const getTbDeptSyncLogPage = (params) => {
  return axios.post(`${base}/api/department/GetTbDeptSyncLogPage`, params);
};

export const getTbDeptSyncLog = (params) => {
  return axios.get(`${base}/api/department/GetTbDeptSyncLog`, { params });
};

export const getTbDeptSyncLogDetailPage = (params) => {
  return axios.post(`${base}/api/department/GetTbDeptSyncLogDetailPage`, params);
};

export const deleteTbDeptSyncLog = (params) => {
  return axios.post(`${base}/api/department/DeleteTbDeptSyncLog`, params);
};

/** 重试天波部门同步失败项。最后更新：2026-09-01 */
export const retryTbDeptSyncFailed = (params) => {
  return axios.post(`${base}/api/department/RetryTbDeptSyncFailed`, params);
};

/** 查询部门同步当前筛选下可重试明细 ID。最后更新：2026-09-01 */
export const getTbDeptSyncRetryableDetailIds = (params) => {
  return axios.post(`${base}/api/department/GetTbDeptSyncRetryableDetailIds`, params);
};

// 卡号信息模块

export const unbindTerminalPowerOnOff = (params) => {
  return axios.post(`${base}/api/PowerOnOffSchedule/UnbindTerminal`, params);
};

//手动授权指定班牌定时开关机

export const manualAuthorizeTerminalPowerOnOff = (params) => {
  return axios.post(
    `${base}/api/PowerOnOffSchedule/ManualAuthorizeTerminal`,
    params,
  );
};

//批量授权指定班牌定时开关机

export const getMoralConfig = (params) => {
  return axios.get(`${base}/api/department/GetMoralConfig`, {
    params: params,
  });
};

// 设置德育配置

export const setMoralConfig = (params) => {
  return axios.post(`${base}/api/department/SetMoralConfig`, params);
};

/** 运维台：德育历史回填（MoralOpsMaintenanceController）。创建于 2026-05-30 */

export const studentCardOpsExecuteBatchUnbindByDepartment = (data) => {
  return axios.post(`${base}/api/StudentCardOpsMaintenance/ExecuteBatchUnbindByDepartment`, data);
};

export const getFlowingRedFlagConfig = (params) => {
  return axios.get(`${base}/api/department/GetFlowingRedFlagConfig`, {
    params: params,
  });
};

// 设置流动红旗配置

export const setFlowingRedFlagConfig = (params) => {
  return axios.post(`${base}/api/department/SetFlowingRedFlagConfig`, params);
};

// 获取值日检查笑脸配置

export const getDutyInspectSmileConfig = (params) => {
  return axios.get(`${base}/api/department/GetDutyInspectSmileConfig`, {
    params: params,
  });
};

// 保存值日检查笑脸配置

export const setDutyInspectSmileConfig = (params) => {
  return axios.post(`${base}/api/department/SetDutyInspectSmileConfig`, params);
};

// 获取成长树阶段配置

export const getGrowthTreeStageConfig = (params) => {
  return axios.get(`${base}/api/department/GetGrowthTreeStageConfig`, {
    params: params,
  });
};

// 保存成长树阶段配置

export const setGrowthTreeStageConfig = (params) => {
  return axios.post(`${base}/api/department/SetGrowthTreeStageConfig`, params);
};

/** 获取电子学生证德育推送配置。创建于 2026-11-03 */
export const getEcardMoralPushConfig = (params) => {
  return axios.get(`${base}/api/EcardMoralPushConfig/GetEcardMoralPushConfig`, {
    params: params,
  });
};

/** 保存电子学生证德育推送配置。创建于 2026-11-03 */
export const setEcardMoralPushConfig = (params) => {
  return axios.post(`${base}/api/EcardMoralPushConfig/SetEcardMoralPushConfig`, params);
};

/** 模拟推送一条德育评价。创建于 2026-11-03 */
export const testEcardMoralPush = (params) => {
  return axios.post(`${base}/api/EcardMoralPushConfig/TestEcardMoralPush`, params);
};

// 获取请假审批流程配置（部门维度）

export const getLeaveApprovalConfig = (params) => {
  return axios.get(`${base}/api/department/GetLeaveApprovalConfig`, {
    params: params,
  });
};

// 保存请假审批流程配置

export const setLeaveApprovalConfig = (params) => {
  return axios.post(`${base}/api/department/SetLeaveApprovalConfig`, params);
};

/** 部门配置：家长微信标准模板配置状态（缺哪些）。创建于 2026-07-25 */
export const getParentWeChatTemplateStatus = (params) => {
  return axios.get(`${base}/api/department/GetParentWeChatTemplateStatus`, {
    params: params,
  });
};

//获取放学大屏展示数据

/** ?????????? 2026-08-07 */
export const getSchoolPayConfig = (params) => axios.get(`${base}/api/SchoolPayConfig/Get`, { params });
export const saveSchoolPayConfig = (params) => axios.post(`${base}/api/SchoolPayConfig/Save`, params);
export const getSchoolAliPayOptions = () => axios.get(`${base}/api/SchoolPayConfig/GetAliPayOptions`);
export const getSchoolWxPayOptions = () => axios.get(`${base}/api/SchoolPayConfig/GetWxPayOptions`);
